import * as React from "react";
import { Cloud24Regular, Cloud24Filled } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";
import { SovCloudRoutes } from "./Shared/Models/SovCloudRoutes";

const SovereignCloudOpsApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "HelloWorld" */ "./SovereignCloudOpsApp");
    return { default: namedExport.SovereignCloudOpsApp };
});

export const SovCloudOps: TeamAppConfig = {
    title: "Sovereign Cloud Operations",
    regularIcon: Cloud24Regular,
    filledIcon: Cloud24Filled,
    description: "Sovereign Cloud Operations Application to provide single pane of glass for Public and Sovereign Cloud",
    team: "SovereignCloudOperations",
    publicId: "EATM365OPERATIONSCENTER\\M365OpsCenterDeploymentTracker",
    owner: "M365OCDeployTracker@microsoft.com",
    role: "*",
    tags: ["OpsCenter", "M365", "Operations", "Monitoring", "Deployment", "Troubleshooting", "Sovereign"],
    app: SovereignCloudOpsApp,
    path: SovCloudRoutes.base
};
